<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-card>
                    <v-card-title>
                        لیست نوع جنس بار
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <div class="row ">
                                <v-data-table
                                    dense
                                    height="400"
                                    fixed-header
                                    hide-default-footer
                                    disable-pagination
                                    multi-sort
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items="items"
                                >
                                    <template v-slot:item.operation="{ item }">

                                        <v-btn @click="edit_item(item)"
                                               title="ویرایش"
                                               outlined small color="warning">
                                            <v-icon
                                                    small
                                                    color="warning"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                        <v-btn @click="delete_item_dialog(item)"
                                               title="حذف"
                                               outlined small color="error">
                                            <v-icon
                                                    small
                                                    color="error"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                </v-data-table>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-card-title>
                        افزودن نوع بار
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                            dense
                            id="load_type_code"
                                v-model="model.code"
                                @keypress="isNumber"
                                v-on:keyup.enter="another_focus('load_type_name')"
                                label="کد بار"/>
                        <v-text-field
                                id="load_type_name"
                                dense
                                v-model="model.name"
                                v-on:keyup.enter="another_focus('add_load_type')"
                                label="نام بار"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="status_form==0" color="success" id="add_load_type" @click="insert_data()">ثبت</v-btn>
                        <v-btn v-if="status_form!=0" color="warning" id="add_load_type" @click="insert_data()">ویرایش
                        </v-btn>
                        <v-btn color="warning" @click="reset_form()">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import { bus } from '../main'
    import Vue from 'vue'

    export default {
        name: 'LoadType',
        components: {},
        data () {
            return {
                confirm_delete_name:"confirm_delete"+new Date().getTime()+"_"+this.$vnode.tag,
                items: [],
                status_form: 0,
                model: {
                    code: '',
                    name: '',
                },
                headers: [
                    {
                        text: 'کد بار',
                        value: 'code'
                    },
                    {
                        text: 'نام بار',
                        value: 'name'
                    }, {
                        text: 'توضیحات',
                        value: 'summary'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ]
            }
        },
        mounted () {
            this.get_data()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        },
        methods: {
            reset_form () {
                this.model = {
                    code: '',
                    name: '',
                }
                this.status_form = 0
            },
            edit_item (item) {
                this.model = JSON.parse(JSON.stringify(item))
                this.status_form = item.id
            },
            get_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/load_type/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/load_type/insert'
                if (this.status_form != 0) {
                    url = '/api/load_type/update'
                    formData.append('id', this.status_form)
                }
                formData.append('code', this.model.code)
                formData.append('name', this.model.name)

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal("هشدار", "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);
                this.status_form = item.id;

            },
            delete_item() {
                const self = this;
                const formData = new FormData()
                const url = '/api/load_type/delete';
                formData.append('id', this.status_form);

                this.axios.post(url, formData, {}).then((res) => {

                    if (res.data.error == 0) {
                        self.$root.modal_component.show_api_response_modals(res);
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', res.data.msg)
                    }
                    self.status_form = 0;

                    self.get_data();


                })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        }
    }
</script>
